;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import "./icon.scss";
import classNames from "classnames";
import React from "react";
import {Button} from "@/components/ui/button";
import chevronDown from "./Icons/chevron-down.svg";
import closeIcon from "./Icons/close.svg";
import facebookIcon from "./Icons/facebook.svg";
import instagramIcon from "./Icons/instagram.svg";
import linkedinIcon from "./Icons/linkedin.svg";
import searchIcon from "./Icons/search.svg";
import youtubeIcon from "./Icons/youtube.svg";

export type IconName =
	| "facebook"
	| "instagram"
	| "linkedin"
	| "youtube"
	| "search"
	| "chevronDown"
	| "close";

type Icons = {
	[key in IconName]: React.FC;
};

const MappedIcons: Icons = {
	facebook: facebookIcon,
	instagram: instagramIcon,
	linkedin: linkedinIcon,
	youtube: youtubeIcon,
	search: searchIcon,
	chevronDown: chevronDown,
	close: closeIcon,
};

function isValidIconName(name: string): name is IconName {
	return (MappedIcons as Record<string, React.FC>)[name] !== undefined;
}

interface Props {
	name: string | IconName;
	className?: string;
	circle?: boolean;
	circleDark?: boolean;
	onClick?: () => void;
}

export default function Icon({ name, className, onClick }: Props) {
	if (!isValidIconName(name)) {
		return <div>Icon not found!</div>;
	}

	if (!onClick) {
		return (
			<div className={classNames("icon", className)}>
				{React.createElement(MappedIcons[name])}
			</div>
		);
	} else {
		return (
			<Button
				className={classNames("icon", className)}
				onClick={(e) => {
					e.preventDefault();
					onClick();
				}}
			>
				{React.createElement(MappedIcons[name])}
			</Button>
		);
	}
}
